import React from 'react'
import styled from 'styled-components'
import truncateMiddle from 'truncate-middle'

import Caption1 from '../components/typography/captions/Caption1'
import Caption4 from '../components/typography/captions/Caption4'
import { getFriendlyCommentSectionLabel } from './comments'
import { capitalizeWord, getTruncatedString } from './string'
import {
  CommentEditedIcon,
  CommentPostedIcon,
  EditIcon,
  InternalApprovedIcon,
  InternalRemovedIcon,
  QualityApprovedIcon,
  QualityRejectedIcon,
  AssignedIcon,
  UnassignedIcon,
  CreateQuestIcon,
  IconWrapper,
  ReviewReturnedLabelIcon,
  DraftLabelIcon,
  PublishedLabelIcon,
  InQualityReviewLabelIcon,
  ReviewCommentIcon,
  DeleteIcon,
  ActivityAddIcon,
  ActivitiesSortedIcon
} from '../components/quest/questhistory/_Styled'
import { activityEditFields } from '../constants/activity'

const EventName = styled(Caption1)`
  color: black;
`

const FlexWrapper = styled.div`
  display: flex;
  align-items: center;
`

const getHistoryEventText = event => {
  let retVal = null
  switch (event.action) {
    case 'resource': {
      retVal = (
        <FlexWrapper>
          <IconWrapper>
            <EditIcon />
          </IconWrapper>
          <Caption4>Activity {event.metadata.activity.number}</Caption4>
          <Caption1>&nbsp;Resource&nbsp;</Caption1>
          <Caption4>
            {truncateMiddle(
              `\u00A0"${event.metadata.resource.name}"\u00A0`,
              20,
              20,
              '...'
            )}
          </Caption4>
          <Caption1>{`\u00A0${
            getActivityEventElements(event.metadata).text
          }\u00A0`}</Caption1>
          <EventName>
            {getTruncatedString({
              val: event.metadata.editor.name,
              len: 45
            })}
          </EventName>
        </FlexWrapper>
      )
      break
    }
    case 'activity_note': {
      retVal = (
        <FlexWrapper>
          <IconWrapper>
            <EditIcon />
          </IconWrapper>
          <Caption4>Activity {event.metadata.activity.number}</Caption4>
          <Caption1>&nbsp;Mentor File&nbsp;</Caption1>
          <Caption4>
            {truncateMiddle(
              `\u00A0"${event.metadata.note.file_name}"\u00A0`,
              20,
              20,
              '...'
            )}
          </Caption4>
          <Caption1>{`\u00A0${
            getActivityEventElements(event.metadata).text
          }\u00A0`}</Caption1>
          <EventName>
            {getTruncatedString({
              val: event.metadata.editor.name,
              len: 45
            })}
          </EventName>
        </FlexWrapper>
      )
      break
    }
    case 'activity': {
      isActivitiesSort(event.metadata)
        ? (retVal = (
            <FlexWrapper>
              <IconWrapper>
                <ActivitiesSortedIcon />
              </IconWrapper>
              <Caption4>Activities sorted by&nbsp;</Caption4>
              <EventName>
                {getTruncatedString({
                  val: event.metadata.editor.name,
                  len: 45
                })}
              </EventName>
            </FlexWrapper>
          ))
        : (retVal = (
            <FlexWrapper>
              <IconWrapper>
                {getActivityEventElements(event.metadata).icon}
              </IconWrapper>
              <Caption4>Activity {event.metadata.activity.number}</Caption4>
              <Caption1>{`\u00A0${
                getActivityEventElements(event.metadata).text
              }\u00A0`}</Caption1>
              <EventName>
                {getTruncatedString({
                  val: event.metadata.editor.name,
                  len: 45
                })}
              </EventName>
            </FlexWrapper>
          ))
      break
    }
    case 'edit': {
      retVal = (
        <FlexWrapper>
          <IconWrapper>
            <EditIcon />
          </IconWrapper>
          <Caption4>
            {translateSectionToReadable(event.metadata.section)}
          </Caption4>
          <Caption1>{'\u00A0edited by\u00A0'}</Caption1>
          <EventName>
            {getTruncatedString({
              val: event.metadata.editor.name,
              len: 45
            })}
          </EventName>
        </FlexWrapper>
      )
      break
    }

    case 'unassignment': {
      retVal = (
        <FlexWrapper>
          <IconWrapper>
            <UnassignedIcon />
          </IconWrapper>
          <EventName>
            {getTruncatedString({
              val: event.metadata.unassigned_by.name,
              len: 36
            })}
          </EventName>
          <Caption1>{'\u00A0unassigned this quest to\u00A0'}</Caption1>
          <EventName>
            {getTruncatedString({
              val: event.metadata.assigned_to.name,
              len: 36
            })}
          </EventName>
        </FlexWrapper>
      )
      break
    }

    case 'assignment': {
      retVal = (
        <FlexWrapper>
          <IconWrapper>
            <AssignedIcon />
          </IconWrapper>
          <EventName>
            {getTruncatedString({
              val: event.metadata.assigned_by.name,
              len: 36
            })}
          </EventName>
          <Caption1>{'\u00A0assigned this quest to\u00A0'}</Caption1>
          <EventName>
            {getTruncatedString({
              val: event.metadata.assigned_to.name,
              len: 36
            })}
          </EventName>
        </FlexWrapper>
      )
      break
    }

    case 'internal_review': {
      retVal = (
        <FlexWrapper>
          <IconWrapper>
            {event.metadata.approved ? (
              <InternalApprovedIcon />
            ) : (
              <InternalRemovedIcon />
            )}
          </IconWrapper>
          <Caption4>
            {`Internal Review [${capitalizeWord(event.metadata.criteria)}]`}
          </Caption4>
          <Caption1>{`\u00A0${
            event.metadata.approved ? 'approved by' : 'approval removed by'
          }\u00A0`}</Caption1>
          <EventName>
            {getTruncatedString({
              val: event.metadata.reviewer.name,
              len: 45
            })}
          </EventName>
        </FlexWrapper>
      )
      break
    }

    case 'platform_review': {
      retVal = (
        <FlexWrapper>
          <IconWrapper>
            {event.metadata.approved ? (
              <QualityApprovedIcon />
            ) : (
              <QualityRejectedIcon />
            )}
          </IconWrapper>
          {event.comment ? (
            <div style={{ marginRight: '8px' }}>
              <ReviewCommentIcon />
            </div>
          ) : null}
          <Caption4>{`Publication Review [${capitalizeWord(
            event.metadata.criteria
          )}]`}</Caption4>
          <Caption1>{`\u00A0${
            event.metadata.approved ? 'approved by' : 'not approved by'
          }\u00A0`}</Caption1>
          <EventName>
            {getTruncatedString({
              val: event.metadata.reviewer.name,
              len: 45
            })}
          </EventName>
        </FlexWrapper>
      )
      break
    }

    case 'state_change': {
      const labelIcon = getLabelIcon(event.metadata.to_state)
      retVal = (
        <FlexWrapper>
          <div style={{ marginRight: '19px' }}>{labelIcon}</div>
          <Caption1>Quest state changed by{'\u00A0'}</Caption1>
          <EventName>
            {getTruncatedString({
              val: event.metadata.user.name,
              len: 45
            })}
          </EventName>
        </FlexWrapper>
      )
      break
    }

    case 'creation': {
      retVal = (
        <FlexWrapper>
          <IconWrapper>
            <CreateQuestIcon />
          </IconWrapper>
          <Caption1>Quest created by{'\u00A0'}</Caption1>
          <EventName>
            {getTruncatedString({
              val: event.metadata.author.name,
              len: 45
            })}
          </EventName>
        </FlexWrapper>
      )
      break
    }

    case 'comment': {
      let action = ''
      if (event.metadata.new_post) {
        action = 'posted'
      } else if (event.metadata.deleted) {
        action = 'deleted'
      } else {
        action = 'edited'
      }
      retVal = (
        <FlexWrapper>
          <IconWrapper>
            {event.metadata.new_post ? (
              <CommentPostedIcon />
            ) : (
              <CommentEditedIcon />
            )}
          </IconWrapper>
          <Caption4>{getFriendlyCommentSectionLabel(event.metadata)}</Caption4>
          <Caption1>{`\u00A0comment ${action} by\u00A0`}</Caption1>
          <EventName>
            {getTruncatedString({
              val: event.metadata.user.name,
              len: 45
            })}
          </EventName>
        </FlexWrapper>
      )
      break
    }
  }

  return retVal
}

const translateSectionToReadable = section => {
  let retVal = ''
  switch (section) {
    case 'basic_info': {
      retVal = 'Basic Information'
      break
    }
    case 'other_information': {
      retVal = 'Other Information'
      break
    }
    case 'images': {
      retVal = 'Images'
      break
    }
    case 'topics_and_standards': {
      retVal = 'Topics & Standards'
      break
    }
    case 'activities': {
      retVal = 'Activities'
      break
    }
    case 'questhistory': {
      retVal = 'Quest History'
      break
    }
    case 'quest_skills': {
      retVal = 'Quest Skills'
      break
    }
    default: {
      retVal = 'Unknown'
    }
  }
  return retVal
}

const getLabelIcon = reviewStatus => {
  var retVal = null
  switch (reviewStatus) {
    case 'submitted':
      retVal = <InQualityReviewLabelIcon />
      break
    case 'draft':
      retVal = <DraftLabelIcon />
      break
    case 'platform_review':
      retVal = <InQualityReviewLabelIcon />
      break
    case 'published':
      retVal = <PublishedLabelIcon />
      break
    case 'rejected':
      retVal = <ReviewReturnedLabelIcon />
      break
    case 'recalled':
      retVal = <DraftLabelIcon />
      break
  }
  return retVal
}

const shouldHideHistoryEvent = event =>
  !getHistoryEventText(event) ||
  (event.action === 'state_change' &&
    event.metadata.to_state === 'platform_review')

const getActivityEventElements = data => {
  let text = ''
  let icon = null
  switch (data.action) {
    case 'create': {
      text = data.note || data.resource ? 'added by' : 'created by'
      icon = <ActivityAddIcon />
      break
    }
    case 'update': {
      text = 'edited by'
      icon = <EditIcon />
      break
    }
    case 'destroy': {
      text = 'deleted by'
      icon = <DeleteIcon />
    }
  }
  return { text, icon }
}

const isActivitiesSort = data =>
  data.action === 'update' && data.changed_attributes.includes('activity_order')

const eventExpandable = event => {
  let retVal = null
  // is platform review with a comment to see
  if (event.action === 'platform_review' && Boolean(event.comment)) {
    retVal = {
      type: 'review',
      text: 'Review'
    }
  } else if (
    event.action === 'activity' &&
    event.metadata.action === 'update' &&
    !isActivitiesSort(event.metadata)
  ) {
    retVal = {
      type: 'activity',
      text: 'Details'
    }
  }
  return retVal
}

const sortActivitityEditAttributes = attributes =>
  attributes.sort(
    (a, b) => activityEditFields[a].index - activityEditFields[b].index
  )

export {
  getHistoryEventText,
  translateSectionToReadable,
  getLabelIcon,
  shouldHideHistoryEvent,
  isActivitiesSort,
  eventExpandable,
  sortActivitityEditAttributes
}



// WEBPACK FOOTER //
// ./src/utils/questhistory.js